import { useQuery } from '@tanstack/react-query';

import { PlayerStatsResponse } from '@/modules/rankings/ppr/types';

export const useGetRankHistoryPlayerStats = (
  slug: string,
  divisionType: string | null,
  enabled = true
) => {
  return useQuery({
    queryKey: ['rank_history_data', slug, divisionType],
    queryFn: () => getRankHistoryPlayerStats(slug, divisionType),
    enabled: enabled && slug !== '',
    refetchOnWindowFocus: false,
  });
};

async function getRankHistoryPlayerStats(
  slug: string,
  divisionType: string | null
): Promise<
  | {
      rankHistoryPlayerStats: PlayerStatsResponse;
    }
  | undefined
> {
  try {
    const params = new URLSearchParams({ slug });
    if (divisionType !== null) {
      params.set('divisionType', divisionType);
    }
    const response = await fetch(`/api/v2/rankings/getRankHistoryPlayerStats?${params.toString()}`);

    if (response.ok) {
      const data: {
        data: { rankHistoryPlayerStats: PlayerStatsResponse };
      } = await response.json();
      return data.data;
    } else {
      throw new Error('Failed to fetch data');
    }
  } catch {
    return undefined;
  }
}
